module.exports = __webpack_public_path__ + "static/img/Aions_Mar_9.dfab533.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_Mar/Aions_Mar_9.png
// module id = lcG2
// module chunks = 19